import styled from "styled-components";

export const Container = styled.div`
  margin-top: 24px;
`;

export const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
`;
